import React, { useState } from "react";
import logo from "../Assets/images/logo-white.png";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple check
    if (!email) {
      setMessage("Please enter an email address!");
      return;
    }

    try {
      setLoading(true);
      // Send the email to your backend via fetch (JSON body)
      const response = await fetch("https://emd.global/email_subscribe.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.status === "success") {
        setLoading(false);
        setMessage("Thank you for subscribing! We’ll notify you soon.");
      } else {
        setLoading(false);
        setMessage("Subscription failed. Please try again.");
      }
    } catch (error) {
      // Catch any network or unexpected errors
      setMessage("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
      // Reset input field regardless of success or failure
      setEmail("");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="footer-bg dark-bg">
        <div className="height-emulator" />
        <footer className="main-footer">
          <div className="footer-inner">
            <div className="container">
              {/* footer-widget-wrap */}
              <div className="footer-widget-wrap">
                <div className="footer-separator-wrap">
                  <div className="footer-separator">
                    <span />
                  </div>
                </div>
                <div className="row">
                  {/* footer-widget */}
                  <div className="col-lg-4">
                    <div className="footer-widget">
                      <div className="footer-widget-title">About us</div>
                      <div className="footer-widget-content">
                        <p style={{ textAlign: "justify", fontSize: "14px" }}>
                          Welcome to Earth Mined Diamonds LLP, your trusted
                          source for exquisite diamonds and fine jewelry. We are
                          a prominent company dedicated to bringing you the
                          highest quality diamonds, exceptional craftsmanship,
                          and outstanding customer service.
                          <a
                            style={{
                              color: "#b5b7bb",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate("/about");
                            }}
                          >
                            {" "}
                            more...
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* footer-widget  end*/}

                  {/* footer-widget */}
                  <div className="col-lg-3">
                    <div className="footer-widget">
                      <div className="footer-widget-title">Contact info</div>
                      <div className="footer-widget-content">
                        <div className="footer-contacts footer-box">
                          <ul>
                            <li>
                              <span>Call :</span>
                              <a href="tel:+912612609971">+91 2612609971</a>
                              ,&nbsp;
                              <a href="tel:+918320715671">+91 8320715671</a>
                            </li>
                            <li>
                              <span>Write :</span>
                              <a href="mailto:info@emd.global">
                                info@emd.global
                              </a>
                            </li>
                            <li>
                              <span>Find us :</span>
                              <span style={{ width: "60%" }}>
                                A-320 Diamond Village, Moti Bagh Vadi,
                                Jadakhadi, Mahdharpura, Surat – 395003
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* footer-widget  end*/}

                  {/* footer-widget */}
                  <div className="col-lg-2">
                    <div className="footer-widget">
                      <div className="footer-widget-title">Helpful links</div>
                      <div className="footer-widget-content">
                        <div className="footer-list footer-box">
                          <ul>
                            <li>
                              <a
                                onClick={() => {
                                  navigate("/contact");
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                Contacts
                              </a>
                            </li>
                            <li>
                              <a
                                onClick={() => {
                                  navigate("/about");
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                About
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* footer-widget  end*/}

                  {/* footer-widget */}
                  <div className="col-lg-3">
                    <div className="footer-widget">
                      <div className="footer-widget-title">Subscribe</div>
                      <div className="footer-widget-content">
                        <div className="subcribe-form">
                          <p style={{ fontSize: "14px" }}>
                            Want to be notified when we launch a new template or
                            an update? Just sign up and we'll send you a
                            notification by email.
                          </p>
                          <form id="subscribe" onSubmit={handleSubmit}>
                            <input
                              className="enteremail"
                              name="email"
                              id="subscribe-email"
                              placeholder="Your Email"
                              spellCheck="false"
                              type="email"
                              required
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <button
                              type="submit"
                              id="subscribe-button"
                              className="subscribe-button color-bg"
                              disabled={loading}
                            >
                              {loading ? "Sending..." : "Send"}
                            </button>
                          </form>
                          {message && (
                            <div className="subscribe-message">{message}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* footer-widget  end*/}
                </div>
              </div>
              {/* footer-widget-wrap end*/}
            </div>
          </div>

          <div className="footer-social">
            <div className="container">
              <ul>
                <li>
                  <a
                    href="https://www.instagram.com/emd.global"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/earth-mined-diamonds/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <a
                onClick={() => {
                  navigate("/");
                }}
                className="footer-logo"
                style={{ cursor: "pointer" }}
              >
                <img src={logo} alt="Logo" />
              </a>
              <div className="copyright">
                © EARTH MINED DIAMONDS LLP {new Date().getFullYear()}. All
                rights reserved.
              </div>
              <div className="to-top" onClick={scrollToTop}>
                <span>Back To Top</span>
                <i className="fal fa-angle-double-up" />
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;
